import React from 'react';
import { Popover } from 'antd';

const hasSupplementaryInfo = (record) => {
  const value = record?.instructions ?? record?.originalData?.supplementary_info;
  return value !== null && value !== undefined && String(value).trim() !== '';
};

const getSupplementaryInfoText = (record) => {
  const value = record?.instructions ?? record?.originalData?.supplementary_info;
  return String(value || '').trim();
};

export const createProductNameCellRenderer = () => (_, record) => {
  const productName = record?.name || '-';
  const supplementaryInfo = getSupplementaryInfoText(record);
  const shouldShowSupplementaryInfo = hasSupplementaryInfo(record);

  if (!shouldShowSupplementaryInfo) {
    return <span title={productName}>{productName}</span>;
  }

  return (
    <div className="biding__product-name-with-info">
      <span className="biding__product-name-text" title={productName}>
        {productName}
      </span>
      <Popover
        title="Informatii suplimentare"
        content={supplementaryInfo}
        trigger="hover"
      >
        <span
          className="biding__supplementary-info-dot"
          aria-label="Produsul are informatii suplimentare"
        />
      </Popover>
    </div>
  );
};
